import { gql } from '@apollo/client';

export const QueryMakes = gql`
  query Makes {
    makes {
      name
      displayName
    }
  }
`;

export const QueryModelsByMake = gql`
  query Models($makeName: String!) {
    models(makeName: $makeName) {
      name
      displayName
      subGroups {
        name
        displayName
      }
    }
  }
`;
